document.addEventListener( 'DOMContentLoaded', () => {
  // エンジニア
  const engineerModalOpen = document.querySelectorAll( '.js-engineer-modal-open' );
  const engineerModal = document.querySelectorAll( '.js-engineer-modal' );
  const engineerModalClose = document.querySelectorAll( '.js-engineer-modal-close' );
  const engineerModalInner = document.querySelectorAll( '.js-engineer-modal-inner' );

  engineerModalOpen.forEach( ( item ) => {
    item.addEventListener( 'click', () => {
      const index = item.getAttribute( 'data-engineer-modal-index' );
      const engineerModal = document.querySelector( `.js-engineer-modal[data-engineer-modal-index="${ index }"]` );
      engineerModal.classList.add( 'is-open' );
    } );
  } );

  engineerModal.forEach( ( item ) => {
    item.addEventListener( 'click', (e) => {
      item.classList.remove( 'is-open' );
    } );
  } );

  engineerModalInner.forEach( ( item ) => {
    item.addEventListener( 'click', (e) => {
      e.stopPropagation();
      e.preventDefault();
    } );
  } );

  engineerModalClose.forEach( ( item ) => {
    item.addEventListener( 'click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      item.closest( '.js-engineer-modal' ).classList.remove( 'is-open' );
    } );
  } );

  // 社員
  const modal = document.querySelector( '.js-modal' );
  const modalOpen = document.querySelectorAll( '.js-modal-open' );
  const modalBox = document.querySelector( '.js-modal-box' );
  const modalClose = document.querySelector( '.js-modal-close' );
  const modalContents = document.querySelector( '.js-modal-contents' );

  modalOpen.forEach( ( item ) => {
    item.addEventListener( 'click', () => {
      modal.classList.add( 'is-open' );
      modalContents.scrollTop = 0;
    } );
  } );

  modal.addEventListener( 'click', () => {
    modal.classList.remove( 'is-open' );
  } );

  modalClose.addEventListener( 'click', () => {
    modal.classList.remove( 'is-open' );
  } );

  modalBox.addEventListener( 'click', ( e ) => {
    e.stopPropagation();
  } );
});
